import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Col,
  Row,
  Container,
  Spinner,
} from "react-bootstrap";
import ContextApp from "../../../../core/contexts/context.app";
import ServiceStorage from "../../../../core/services/service.storage";
import SwalMessage from "../../_Components/SwalMessage";
import GetCodeForSendInput from "./GetCodeForSendInput";
import ApiAuth from "../../../../core/api/api.auth";

const VerifyMobile = (props) => {
  const ctx = useContext(ContextApp);
  const [timeForSendCod, setTimeForSendCod] = useState(60); // timer for get agine cod
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSendCode, setIsLoadingSendCode] = useState(false);
  // جهت مدیریت کامپوننت ورود 4 رقم اسمس
  const [getCodeProps, setGetCodeProps] = useState({
    deleteForm: true,
    codeLogin: "",
    codeIsValid: true,
  });

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (timeForSendCod > 0) {
        setTimeForSendCod(timeForSendCod - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  async function onSubmit(event) {
    event.preventDefault();
    if (getCodeProps.codeLogin.replaceAll(" ", "").length < 4) {
      setGetCodeProps({ ...getCodeProps, codeIsValid: false });
      SwalMessage({
        title: " کد ارسالی باید 4 رقمی باشد ",
        iSsuccess: false,
      });
      return;
    }
    setIsLoading(true);
    try {
      if (getCodeProps.codeLogin.replaceAll(" ", "").length < 4) {
        setGetCodeProps({ ...getCodeProps, codeIsValid: false });
        SwalMessage({
          title: " کد ارسالی باید 4 رقمی باشد ",
          iSsuccess: false,
        });
        return;
      } else {
        const result = await ApiAuth.verifyMobile({
          phoneNumber: props.mobileLogin,
          token: getCodeProps.codeLogin,
        });

        if (result.succeeded == false || result.data == null) {
          SwalMessage({ title: result.message, iSsuccess: result.succeeded });
          return;
        } else {
          if (
            result.succeeded == true &&
            result.data != null &&
            result.data.jwToken != null
          ) {
            ServiceStorage.setToken(
              result.data.jwToken,
              result.data.refreshToken
            );
            ctx.setIsAuth(true);

            //تکمیل اطلاعات کاربر
            // ServiceStorage.setUserInfo({ name: result.data.name, phone: result.data.userName, email: result.data.email, walletRiallBalance: result.data.walletRiallBalance, basketCount: result.data.basketCount });
            // ctx.setUserInfo({ name: result.data.name, phone: result.data.userName, email: result.data.email, walletRiallBalance: result.data.walletRiallBalance, basketCount: result.data.basketCount })

            // اول لیست افراد وابسطه به این کاربر اپدیت بشه

            //اپدیت و دریافت اخرین سبد خرید فعال

            // نمایش پیغام
            SwalMessage({ title: "خوش امدید", iSsuccess: true });
            // go to dashbord
            // ?????
          }
        }
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }

  const takeCodeAgain = async (data) => {
    setIsLoadingSendCode(true);
    try {
      //دریافت دوباره کد از سرور و راه اندازی دوباره تایمر
      const response = await ApiAuth.loginByMobile({
        phoneNumber: props.mobileLogin,
      });
      if (response.succeeded == true) {
        setTimeForSendCod(60);
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      } else
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    } finally {
      setIsLoadingSendCode(false);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <Container className="mt-5">
        <Row>
          <Col xs="12" md="5" className="acc my-auto">
            <div>
              <div className="text-center large-svg">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    fill="none"
                    stroke="currentColor"
                    // stroke-linecap="round"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M2.5 9q.045-1.208.27-2.45c.11-.616.166-.924.356-1.135s.66-.36 1.599-.66C7.035 4.019 8.987 2 11.998 2s4.967 2.02 7.277 2.755c.939.3 1.408.449 1.598.66c.19.21.246.519.357 1.135q.225 1.242.27 2.45m-2.055 8c-1.32 2.023-3.268 3.637-5.83 4.618c-.667.255-1 .382-1.614.382c-.612 0-.946-.128-1.613-.383c-2.562-.98-4.51-2.594-5.831-4.617M8.5 12l1 1m0 0l1 1m-1-1l1-1m-1 1l-1 1m-5-2l1 1m0 0l1 1m-1-1l1-1m-1 1l-1 1m10-2l1 1m0 0l1 1m-1-1l1-1m-1 1l-1 1m5-2l1 1m0 0l1 1m-1-1l1-1m-1 1l-1 1"
                    color="currentColor"
                  />
                </svg>
              </div>
              <h6 className="  text-center mt-4"> صفحه دریافت پیامک </h6>
              <p
                className=" text-center mb-2 mt-0"
                style={{ color: "#909090" }}
              >
                <small>
                  کد تایید به شماره موبایل
                  <span className="font-weight-bold text-dark px-1">
                    {props.mobileLogin?.replaceAll(" ", "")[0] !== "0"
                      ? "0" + props.mobileLogin?.replaceAll(" ", "")
                      : props.mobileLogin?.replaceAll(" ", "")}
                  </span>
                  ارسال گردید
                  <br />
                  <span>لطفا کد 4 رقمی ارسال شده را وارد نمایید</span>
                </small>
              </p>

              <GetCodeForSendInput
                setGetCodeProps={setGetCodeProps}
                getCodeProps={getCodeProps}
              />
              <div>
                {isLoading ? (
                  <Button
                    type="submit"
                    variant="outline-primary"
                    className="rounded-pill  px-5  mt-3 d-flex mx-auto"
                    disabled
                  >
                    <Spinner size="sm" />
                    تایید
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    variant="outline-primary"
                    className="rounded-pill  px-5  mt-3 d-flex mx-auto"
                  >
                    تایید
                  </Button>
                )}
              </div>
              <div className="mt-4">
                <Col xs="12" className="">
                  <p className="text-center">
                    <small>
                      در صورتی که پیامک حاوی کد تایید دریافت ننموده اید میتوانید
                      از لینک ذیل جهت ارسال مجدد کد اقدام نمایید.
                    </small>
                  </p>
                </Col>
                <Col xs="12" className="d-flex justify-content-center ">
                  {isLoadingSendCode ? (
                    <>
                      <Button
                        variant="primary"
                        size="sm"
                        className=" rounded-pill t-3  py-1  "
                        disabled
                      >
                        <Spinner size="sm" className="pl-3" /> ارسال کد{" "}
                      </Button>
                    </>
                  ) : (
                    <Button
                      variant={timeForSendCod > 0 ? "secondary" : "primary"}
                      size="sm"
                      className="border-0  rounded-pill t-3  py-1  "
                      disabled={timeForSendCod > 0 && true}
                      onClick={takeCodeAgain}
                    >
                      <span>ارسال کد </span>
                      <small
                        style={{ width: "10px" }}
                        className={
                          timeForSendCod > 0
                            ? "mr-1 text-dark font-weight-bold  d-inline-block"
                            : "text-primary font-weight-bold"
                        }
                      >
                        {" "}
                        {timeForSendCod > 0 ? timeForSendCod : ""}{" "}
                      </small>
                    </Button>
                  )}
                </Col>
              </div>
            </div>
          </Col>
          <Col xs="12" md="7" className="d-none d-md-block text-center">
            <img src="/media/bg/password.svg" alt="" className="w-75" />
          </Col>
        </Row>
      </Container>
    </form>
  );
};

export default VerifyMobile;
